export default __webpack_public_path__ + "static/media/laundry2-beforeB-480w.1a57e123.png";